import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { S_Xmark, S_BarsStaggered } from 'hosman-material';

const MenuButton = ({ sidebarOpen, setSidebarOpen }) => {
  return(
    <button type='button' onClick={() => setSidebarOpen(prev => !prev)} className='bg-ih-indigo-80 py-2 px-3 flex items-center gap-x-2 white rounded-xl' data-testid='menu-button'>
      <span className='h4 text-white'>Menu</span>

      <FontAwesomeIcon
        icon={sidebarOpen ? S_Xmark : S_BarsStaggered}
        className='h-4 w-4 flex items-center text-ih-blue'
      />
    </button>
  )
}

export default MenuButton;

// PropTypes
MenuButton.propTypes = {
  sidebarOpen: PropTypes.bool.isRequired,
  setSidebarOpen: PropTypes.func.isRequired
};
